const companies: { name: string; url: string; urlWhite?: string; scale: number; offsetY?: number; width?: number }[] = [
  { name: "Instacart", url: "/logos/instacart.svg", scale: 1.0, width: 150 },
  { name: "Salesforce", url: "/logos/salesforce.svg", urlWhite: "/logos/salesforce-white.svg", scale: 1.0, width: 150 },
  { name: "Hugging Face", url: "/logos/huggingface.svg", urlWhite: "/logos/huggingface-white.svg", scale: 1.3, width: 150 },
  { name: "McKinsey", url: "/logos/mckinsey.svg", scale: 1.0, width: 220 },
  { name: "Red Hat", url: "/logos/redhat.svg", urlWhite: "/logos/redhat-white.svg", scale: 0.9, width: 150 },
  { name: "Shopify", url: "/logos/shopify.svg", urlWhite: "/logos/shopify-white.svg", scale: 0.9, width: 150 },
  { name: "Constant Contact", url: "/logos/constant-contact.svg", scale: 1.1, width: 220 },
  { name: "Interac", url: "/logos/interac.svg", urlWhite: "/logos/interac-white.svg", scale: 1.0, width: 130 },
  { name: "Telus", url: "/logos/telus.svg", scale: 1.0, width: 150 },
  { name: "Deloitte", url: "/logos/deloitte.svg", scale: 0.75, width: 150 },
  { name: "Fellow", url: "/logos/fellow.svg", scale: 0.8, width: 120 },
  { name: "Coveo", url: "/logos/coveo.svg", scale: 1.0, width: 150 },
  { name: "EY", url: "/logos/ey.svg", scale: 0.85, offsetY: -6, width: 80 },
];

interface LogoCarouselProps {
  variant?: "light" | "dark";
}

const LogoCarousel = ({ variant = "light" }: LogoCarouselProps) => {
  const baseStyles = "h-[50px] w-auto object-contain";
  // Light: grayscale logos
  const lightStyles = "opacity-60 [filter:grayscale(100%)]";

  // Get the appropriate logo URL and styles based on variant and whether white version exists
  const getLogoConfig = (company: typeof companies[0]) => {
    if (variant === "dark") {
      if (company.urlWhite) {
        // Use white SVG directly, no filter needed
        return {
          url: company.urlWhite,
          className: `${baseStyles} opacity-90`
        };
      } else {
        // Apply filter to convert to white
        return {
          url: company.url,
          className: `${baseStyles} opacity-90 [filter:grayscale(100%)_brightness(0)_invert(1)]`
        };
      }
    } else {
      return {
        url: company.url,
        className: `${baseStyles} ${lightStyles}`
      };
    }
  };

  return (
    <div className="w-full overflow-hidden" role="region" aria-label="Companies we've worked with">
      <div className="flex w-max animate-logo-scroll">
        {/* First set of logos */}
        {companies.map((company, index) => {
          const config = getLogoConfig(company);
          return (
            <div
              key={`first-${index}`}
              className="flex-shrink-0 mx-6 flex items-center justify-center"
              style={{ height: '70px', width: company.width || 140 }}
            >
              <img
                src={config.url}
                alt={`${company.name} logo`}
                width={company.width || 140}
                height={50}
                className={config.className}
                loading="lazy"
                decoding="async"
                style={{ 
                  transform: `scale(${company.scale})${company.offsetY ? ` translateY(${company.offsetY}px)` : ''}` 
                }}
              />
            </div>
          );
        })}
        {/* Duplicate set for seamless loop */}
        {companies.map((company, index) => {
          const config = getLogoConfig(company);
          return (
            <div
              key={`second-${index}`}
              className="flex-shrink-0 mx-6 flex items-center justify-center"
              style={{ height: '70px', width: company.width || 140 }}
            >
              <img
                src={config.url}
                alt={`${company.name} logo`}
                width={company.width || 140}
                height={50}
                className={config.className}
                loading="lazy"
                decoding="async"
                style={{ 
                  transform: `scale(${company.scale})${company.offsetY ? ` translateY(${company.offsetY}px)` : ''}` 
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LogoCarousel;
